import {Outlet} from 'react-router-dom'
import {Header} from '@components/commons/header'
import {Footer} from '@components/commons/footer'
import {ScrollToAnchor} from '@utilities/scroll-to-anchor-listener'

export const PublicLayout = () => {
    return (
        <div className="grid grid-rows-[auto_minmax(0,1fr)] overflow-hidden h-full">
            <Header isPrivate={false} />
            <div className="overflow-y-auto h-full gap-5 grid grid-rows-[1fr_auto]">
                <Outlet />
                <Footer />
                <ScrollToAnchor />
            </div>
        </div>
    )
}
